import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { AuthorizationService } from '../services/authorization.service';

@Injectable({
  providedIn: 'root',
})

export class AuthGuard implements CanActivate {
  constructor(private readonly authenticationService: AuthenticationService, private readonly authorizationService: AuthorizationService) {
  }

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return true;

    // const currentUser = this._authenticationService.currentUserValue;
    // localStorage.setItem('returnUrl', state.url);

    // if (currentUser || localStorage.getItem('isByPass') === 'true') {
    //   return true;
    // }

    // this._authenticationService.login();
    // return false;
  }
}
